import { render, staticRenderFns } from "./TopAlert.vue?vue&type=template&id=0129491d&"
import script from "./TopAlert.vue?vue&type=script&lang=js&"
export * from "./TopAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports